exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#mainViews {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  align-content: stretch;\r\n  flex-grow: 1;\r\n  align-content: flex-start;\r\n  overflow-y: hidden;\r\n}\r\n#mainViews .view {\r\n  height: 100%;\r\n  display: none;\r\n  flex-grow: 10;\r\n}\r\n#mainViews .view.active {\r\n  display: flex;\r\n}", ""]);

// exports
